import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const IrpIncidence = 'IrpIncidences'

export const getIrpIncidences = (filters) => {
  return axios.post(`/${IrpIncidence}/PaginatedAndFiltered`, filters)
}

export const getIrpIncidence = (id) => {
  return axios.get(`/${IrpIncidence}/${id}`)
}

export const acceptIrpIncidence = (data) => {
  return axios.put(`/${IrpIncidence}`, data)
}
